/**
 * DWA brand tokens for the Hubs shell (entryway, Hub pages, Hub header, Lupa widget).
 *
 * Values come from colours already used in this codebase:
 *   - gold `#fec35c`        — Lupa accent (`--color-accent` in index.css, LUPA_GOLD in the dashboards)
 *   - on-gold `#111111`     — button text on gold (DWA brand, migration 031 `button_text_color`)
 *   - dark `#1a1a1a`        — DWA brand dark (migration 031 `bg_color`, the wolf-icon disc)
 *   - ink / secondary / muted / page — the DWA Internal dashboard theme
 *
 * The same values are exposed as CSS custom properties (`--dwa-*`) in index.css for
 * stylesheet use. Change a colour in both places.
 */
export const DWA = {
  gold: '#fec35c',
  goldHover: '#ffd27f',
  goldSoft: 'rgba(254, 195, 92, 0.14)',
  onGold: '#111111',
  dark: '#1a1a1a',
  darkSoft: '#2d2d2d',
  darkBar: 'rgba(10, 10, 10, 0.97)',
  ink: '#1a202c',
  textSecondary: '#4a5568',
  textMuted: '#94a3b8',
  onDark: '#f8fafc',
  onDarkMuted: '#a0aec0',
  pageBg: '#f8f8f6',
  cardBg: 'rgba(255, 255, 255, 0.96)',
  cardBorder: 'rgba(0, 0, 0, 0.08)',
  cardShadow: '0 10px 30px -12px rgba(0, 0, 0, 0.35)',
  danger: '#dc2626',
  warning: '#f59e0b',
  positive: '#15803d',
  /** Hubs shell (left rail, fly-outs, top bar): the dark #1a1a1a family. */
  rail: '#1a1a1a',
  railFlyout: '#242424',
  railLine: 'rgba(255, 255, 255, 0.08)',
  railHover: 'rgba(255, 255, 255, 0.07)',
  railActive: 'rgba(254, 195, 92, 0.16)',
  /** Gold for text/icons on the light page background (plain gold fails contrast there). */
  goldInk: '#8a5a00',
  lineLight: '#e5e7eb',
  font: 'Lato, system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
  /**
   * Corner radius for cards, panels, buttons, inputs and menus: Lupa's 4px (the chat,
   * its sidebar and the dashboards all use it), so the whole app matches (Jon,
   * 2026-11-03). Round things (avatars, pills, the Lupa button) stay round.
   */
  radius: '4px',
  /**
   * Entryway / Hub page background: the same dark background as prod's login screen
   * (AuthPage), so the white cards stand out. Dashboards keep the light pageBg.
   * Jon, 2026-11-03 (07-hubs §7.4).
   */
  entrywayBackground: 'linear-gradient(to top right, #000000 0%, #313131 100%)',
} as const;
